import { environment } from '@env/environment';
import * as CryptoJS from 'crypto-js';
var CryptographyService = /** @class */ (function () {
    function CryptographyService() {
    }
    CryptographyService.prototype.encrypt = function (value, key) {
        if (key === void 0) { key = ""; }
        var aesK = (key == null || key == "") ? CryptoJS.enc.Utf8.parse(this.dfgdf) : CryptoJS.enc.Utf8.parse(key);
        var tmp = CryptoJS.AES.encrypt(value, aesK, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }).toString().trim();
        return tmp;
    };
    CryptographyService.prototype.decrypt = function (textToDecrypt, key) {
        if (key === void 0) { key = ""; }
        var aesK = (key == null || key == "") ? CryptoJS.enc.Utf8.parse(this.dfgdf) : CryptoJS.enc.Utf8.parse(key);
        var tmp = CryptoJS.AES.decrypt(textToDecrypt, aesK, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }).toString(CryptoJS.enc.Utf8).trim();
        if (tmp != null && tmp == "True") {
            return true;
        }
        else if (tmp != null && tmp == "False") {
            return false;
        }
        return tmp;
    };
    CryptographyService.prototype.encryptQueryString = function (para, key) {
        var _this = this;
        if (key === void 0) { key = ""; }
        var params = para.split("&");
        var encrypted = "";
        params.forEach(function (p) {
            var kv = p.split("=");
            encrypted += (encrypted != "") ? "&" : "";
            encrypted += kv[0] + "=" + _this.encrypt(kv[1], key);
        });
        return encrypted;
    };
    CryptographyService.prototype.encryptDictValue = function (obj, key) {
        if (key === void 0) { key = ""; }
        try {
            if (obj == null) {
                return null;
            }
            var countArray = 0, countKey = 0, countKeyIn = 0, countKeyEncrypted = 0;
            for (var k in obj) {
                countKey++;
                if (obj.hasOwnProperty(k)) {
                    countKeyIn++;
                    if (obj[k] != null) {
                        if (obj[k].constructor == Object || Array.isArray(obj[k])) {
                            countArray++;
                            obj[k] = this.encryptDictValue(obj[k], key);
                        }
                        else {
                            var objValue = this.tryParseJsonstring(obj[k]);
                            if (objValue.constructor == Object || Array.isArray(objValue)) {
                                var tmp = this.encryptDictValue(objValue, key);
                                obj[k] = tmp;
                            }
                            else if (obj[k] != null && obj[k].toString().trim() != "") {
                                countKeyEncrypted++;
                                try {
                                    obj[k] = this.encrypt(obj[k].toString(), key);
                                }
                                catch (e) {
                                    console.error(e);
                                }
                            }
                        }
                    }
                }
            }
        }
        catch (e) {
            console.error(e);
        }
        return obj;
    };
    CryptographyService.prototype.decryptDictValue = function (obj, key) {
        var _this = this;
        if (key === void 0) { key = ""; }
        try {
            if (obj == null) {
                return null;
            }
            if (Array.isArray(obj)) {
                obj.forEach(function (o) {
                    for (var k in o) {
                        if (o.hasOwnProperty(k)) {
                            if (o[k] != null) {
                                if (o[k].constructor == Object || Array.isArray(o[k])) {
                                    var tmp = _this.decryptDictValue(o[k], key);
                                    o[k] = tmp;
                                }
                                else {
                                    var objValue = _this.tryParseJsonstring(o[k]);
                                    if (objValue.constructor == Object || Array.isArray(objValue)) {
                                        var tmp = _this.decryptDictValue(objValue, key);
                                        o[k] = tmp;
                                    }
                                    else if (o[k] != null && o[k].toString().trim() != "" && o[k].constructor != Boolean) {
                                        try {
                                            var tmp = void 0;
                                            if (key != null && key.trim() != "") {
                                                tmp = _this.decrypt(o[k], key);
                                            }
                                            else {
                                                tmp = _this.decrypt(o[k]);
                                            }
                                            o[k] = tmp;
                                        }
                                        catch (e) {
                                            try {
                                                o[k] = _this.decryptDictValue(JSON.parse(o[k]), key);
                                            }
                                            catch (ex) {
                                                console.error(ex);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            }
            else if (obj.constructor == String) {
                return this.decrypt(obj.toString(), key);
            }
            else {
                for (var k in obj) {
                    if (obj.hasOwnProperty(k)) {
                        if (obj[k] != null) {
                            if (obj[k].constructor == Object || Array.isArray(obj[k])) {
                                var tmp = this.decryptDictValue(obj[k], key);
                                obj[k] = tmp;
                            }
                            else {
                                var objValue = this.tryParseJsonstring(obj[k]);
                                if (objValue.constructor == Object || Array.isArray(objValue)) {
                                    var tmp = this.decryptDictValue(objValue, key);
                                    obj[k] = tmp;
                                }
                                else if (obj[k] != null && obj[k].toString().trim() != "" && obj[k].constructor != Boolean) {
                                    try {
                                        var tmp = this.decrypt(obj[k], key);
                                        obj[k] = tmp;
                                    }
                                    catch (e) {
                                        console.error(e);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        catch (e) {
            console.error(e);
        }
        return obj;
    };
    CryptographyService.prototype.genAesKey = function () {
        var salt = CryptoJS.lib.WordArray.random(128 / 8);
        var keySize = environment.keySize;
        var keyBytes = keySize / 8;
        var keyBits = CryptoJS.PBKDF2("lknfsklvjpsg6#$%#lvkdls;jv", salt, { keySize: keySize / 32 });
        var key = keyBits.toString(CryptoJS.enc.Base64);
        if (key.length > keyBytes) {
            var startIndex = (key.length - keyBytes) % 2 == 0 ? (key.length - keyBytes) / 2 : (key.length - keyBytes + 1) / 2;
            key = key.substr(startIndex, keyBytes);
        }
        this.dfgdf = key;
        return key;
    };
    CryptographyService.prototype.rsaEncrypt = function (publicKey, aesKey) {
        var key = forge.pki.publicKeyFromPem(publicKey);
        var encryptText = window.btoa(key.encrypt(aesKey));
        return encryptText;
    };
    CryptographyService.prototype.tryParseJsonstring = function (str) {
        try {
            return JSON.parse(str);
        }
        catch (e) {
            return str;
        }
    };
    return CryptographyService;
}());
export { CryptographyService };



// WEBPACK FOOTER //
// ./src/app/cryptography.service.ts.pre-build-optimizer.js